export default {
  data () {
    return {
      diseaseCategory: [],
      position: 'default',
      showPositionValue: false,
      tips: '',
      showLoading: false,
      content: '',
      orgUid: '',
      orgInfo: {},
      poweredByStyle: {
        position: 'absolute'
      },
    }
  },
  computed:{
    template(){
      return this.$route.meta.template;
    }
  },
  methods:{
    alert (tips) {
      this.position = 'bottom'; //显示位置，可选值 default, top, middle, bottom
      this.showPositionValue = true;
      this.tips = tips;
    },
    loading(show, content) {
      this.showLoading = show;
      this.content = content;
    },
    chat(cnName, enName, id) {
      this.$router.push({path: `/${this.template}/chat/${this.orgUid}`, query: {cnName: cnName, enName: enName, id: id}});
    },
    getOrganization(){
      let url = 'organization/' + this.orgUid;
      this.$http.get(url, null,(res) => {
        this.orgInfo = res.data;
        this.$route.meta.title = this.orgInfo.name + '智能问答';
        let entId = Number(this.orgInfo.entId);
        if(!window._MEIQIA && entId > 0) {
          let scriptNode = document.createElement('script');
          scriptNode.innerHTML = `(function(m,ei,q,i,a,j,s){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};j=ei.createElement(q),s=ei.getElementsByTagName(q)[0];j.async=true;j.charset='UTF-8';j.src='https://static.meiqia.com/dist/meiqia.js?_=t';s.parentNode.insertBefore(j,s);})(window,document,'script','_MEIQIA');_MEIQIA('entId', ${entId})`;
          let header = document.querySelector("head");
          header.appendChild(scriptNode);
        }
      }, () => {
        this.alert('连接不上服务器，请检查网络')
      });
    },
    getAllShowDisease(){
      this.loading(true,'');
      let url = 'department/all/' + this.orgUid + '?show=1';
      this.$http.get(url, null,(res) => {
        this.diseaseCategory = res.data;
        this.loading(false,'');
        this.$nextTick(() => {
          let clientHeight = document.documentElement.clientHeight;
          let contentHeight = this.$refs.mainRef.offsetHeight;
          if (clientHeight - contentHeight < 109) {
            this.poweredByStyle.position = 'relative'
          }
        });
      }, (error) => {
        console.log(error);
        this.loading(false,'');
        this.alert('连接不上服务器，请检查网络')
      });
    },
    initPage() {
      this.orgUid = this.$route.params.orgUid;
      this.getOrganization();
      this.getAllShowDisease();
    },
    more() {
      this.$router.push({path: `/${this.template}/search/${this.orgUid}`});
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/mixins/HomeMixin.js